module.exports = __webpack_public_path__ + "static/img/11.fb9d979.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dglfr/11.png
// module id = D8oh
// module chunks = 0